// extracted by mini-css-extract-plugin
module.exports = {"title":"_88c766c","loginComment":"_2c669c1","crm":"_0f02616","tooltipIcon":"_e5a722d","tooltip":"_88897ef","error":"_f74b917"};